import { HttpClient } from '@store/base';
import {
  GetEstimateNotificationImagesGateway,
  GetEstimateNotificationImagesRequest,
  GetEstimateNotificationImagesResponse,
} from '@store/order';

/**
 * HSMALL-15407 — 견적 알림톡 참고이미지 조회 래퍼.
 * 현재는 변환 없이 원본 응답을 그대로 리턴한다 (Base Gateway 격리용 매핑 구간).
 * 클라이언트 전용 변환 타입이 필요해지면 이 파일에 정의한다.
 */
export class ClientGetEstimateNotificationImagesGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(
    req: GetEstimateNotificationImagesRequest,
  ): Promise<GetEstimateNotificationImagesResponse> {
    return await new GetEstimateNotificationImagesGateway(this.httpClient).exec(
      req,
    );
  }
}
